import Slider, { SliderProps } from 'rc-slider'
import { Controller, useFormContext } from 'react-hook-form'

interface FilterProps extends SliderProps {
  minValue: number
  maxValue: number
  unit: string
  name: string
  className?: string
}

export interface Props extends FilterProps {
  type: 'Slider'
  defaultValue: number
}

export interface RangeProps extends FilterProps {
  type: 'Range'
  defaultValue: [min: number, max: number]
}

export const FormSlider = ({
  minValue,
  maxValue,
  unit,
  name,
  defaultValue,
  type,
  step = 1,
  ...rest
}: Props | RangeProps) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      render={({ field }) => {
        return (
          <div className='FormSlider__wrapper'>
            <label className='FormSlider__label'>
              {formatValue({ type, value: field.value, unit })}
            </label>
            <Slider
              {...field}
              min={minValue}
              step={step}
              max={maxValue}
              className='FormSlider'
              range={type === 'Range'}
              {...rest}
            />
          </div>
        )
      }}
    />
  )
}

interface SliderValue {
  type: 'Slider'
  value: number
  unit: string
}

interface RangeValue {
  type: 'Range'
  value: [min: number, max: number]
  unit: string
}

const formatValue = ({ type, value, unit }: SliderValue | RangeValue) => {
  if (type === 'Slider') {
    return `${value} ${unit}`
  }

  if (type === 'Range') {
    const [min, max] = value

    return `${min} - ${max} ${unit}`
  }

  return null
}
